import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

// Extend dayjs with relativeTime BEFORE using it
dayjs.extend(relativeTime);

const formatDate = (date: string) => {
    return dayjs(date).format("MMMM D, YYYY");
};

const formatDateRelative = (date: string) => {
    return dayjs(date).fromNow(); // e.g., "3 days ago"
};

export { formatDate, formatDateRelative };
